"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowNodeInstanceHttpClient = void 0;
const index_1 = require("../Types/index");
const BaseClient_1 = require("./BaseClient");
const Mappers_1 = require("./Lib/Mappers");
class FlowNodeInstanceHttpClient extends BaseClient_1.BaseClient {
    async queryFlowNodeInstances(query, identity, offset, limit, sortSettings) {
        const url = this.buildUrl(index_1.restSettings.paths.queryFlowNodeInstances, offset, limit, query, sortSettings);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const response = await this.httpClient.get(url, requestAuthHeaders);
        const mappedResult = {
            totalCount: response.result.totalCount,
            flowNodeInstances: response.result.flowNodeInstances.map(Mappers_1.mapFlowNodeInstance.bind(this)),
        };
        return mappedResult;
    }
    async queryActiveTokens(query, identity, offset, limit) {
        const url = this.buildUrl(index_1.restSettings.paths.queryActiveTokens, offset, limit, query);
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const response = await this.httpClient.get(url, requestAuthHeaders);
        const mappedResult = {
            totalCount: response.result.totalCount,
            activeTokens: response.result.activeTokens.map(Mappers_1.mapActiveToken.bind(this)),
        };
        return mappedResult;
    }
    async finishEmptyActivity(emptyActivityInstanceId, identity) {
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const urlRestPart = index_1.restSettings.paths.finishEmptyActivity
            .replace(index_1.restSettings.params.emptyActivityInstanceId, emptyActivityInstanceId);
        const url = this.buildUrl(urlRestPart);
        await this.httpClient.put(url, {}, requestAuthHeaders);
    }
    async finishManualTask(manualTaskInstanceId, identity) {
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const urlRestPart = index_1.restSettings.paths.finishManualTask
            .replace(index_1.restSettings.params.manualTaskInstanceId, manualTaskInstanceId);
        const url = this.buildUrl(urlRestPart);
        await this.httpClient.put(url, {}, requestAuthHeaders);
    }
    async finishUserTask(userTaskInstanceId, userTaskResult, identity) {
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const urlRestPart = index_1.restSettings.paths.finishUserTask
            .replace(index_1.restSettings.params.userTaskInstanceId, userTaskInstanceId);
        const url = this.buildUrl(urlRestPart);
        await this.httpClient.put(url, userTaskResult, requestAuthHeaders);
    }
    async triggerMessageEvent(messageName, processInstanceId, payload, identity) {
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        let urlRestPart = index_1.restSettings.paths.triggerMessageEvent
            .replace(index_1.restSettings.params.eventName, messageName);
        if (processInstanceId) {
            urlRestPart = `${urlRestPart}?process_instance_id=${processInstanceId}`;
        }
        const url = this.buildUrl(urlRestPart);
        await this.httpClient.post(url, payload, requestAuthHeaders);
    }
    async triggerSignalEvent(signalName, payload, identity) {
        const requestAuthHeaders = this.createRequestAuthHeaders(identity);
        const urlRestPart = index_1.restSettings.paths.triggerSignalEvent
            .replace(index_1.restSettings.params.eventName, signalName);
        const url = this.buildUrl(urlRestPart);
        await this.httpClient.post(url, payload, requestAuthHeaders);
    }
}
exports.FlowNodeInstanceHttpClient = FlowNodeInstanceHttpClient;
//# sourceMappingURL=FlowNodeInstanceHttpClient.js.map